import { type AppRelease } from '@store/api/rootEndpoints';

/** The release this bundle was built as; the server's own comes from `/config`. */
export const appRelease: AppRelease = {
  version: import.meta.env.VITE_APP_VERSION || 'dev',
  commit: import.meta.env.VITE_APP_COMMIT || null,
};
